import { Box, Chip, Typography } from "@mui/material";

type InfoBoxProps = {
  title: string;
  value: number | string;
  color?: string;
  bgColor?: string;
  Icon: React.ElementType;
  label?: string;
};

const InfoBox = ({ title, value, color, bgColor, Icon, label }: InfoBoxProps) => {
  return (
    <Box
      sx={{
        border: 1,
        borderColor: "#E8E8E8",
        borderRadius: 1,
        p: 2,
        position: "relative",
        height: "110px",
        background: `linear-gradient(to bottom, ${color} -100%, #ffffff 50%, #ffffff 50%)`,
      }}
    >
      <Box sx={{ width: "70%" }}>
        <Typography variant="subtitle2" sx={{ height: "40px", fontSize: 16 }}>
          {title}
        </Typography>
        <Typography variant="h4" sx={{ mt: 1 }}>
          {value}
        </Typography>
      </Box>

      <Chip
        icon={Icon ? <Icon style={{ color: color }} /> : undefined}
        label={label}
        style={{
          position: "absolute",
          right: "1%",
          top: 16,
          color: color,
          height: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "transparent",
        }}
      />
    </Box>
  );
};

export default InfoBox;
